import { useState } from "react";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";

const RULES = [[/.{12,}/, "En az 12 karakter"], [/[a-z]/, "Küçük harf"], [/[A-Z]/, "Büyük harf"], [/\d/, "Rakam"], [/[^A-Za-z0-9]/, "Sembol"]];

export default function ForcePasswordChange() {
  const { user, reload, logout } = useAuth();
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = RULES.every(([r]) => r.test(f.next)) && f.next === f.again && f.next !== f.current;
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await api.post("/auth/change-password", { current_password: f.current, new_password: f.next }); await reload(); }
    catch (x) { setErr(apiError(x)); }
    setBusy(false);
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
      <form onSubmit={submit} className="panel w-full max-w-md p-6 space-y-4" data-testid="force-password-change">
        <div className="flex items-center gap-2 text-lg font-bold text-slate-900"><KeyRound className="h-5 w-5 text-blue-600" />Şifre değişikliği zorunlu</div>
        <p className="text-sm text-slate-600">{user.name}, güvenliğiniz için devam etmeden önce yeni ve güçlü bir şifre belirleyin.</p>
        <div className="space-y-1.5"><Label>Mevcut şifre</Label><Input type="password" required value={f.current} onChange={set("current")} data-testid="fpc-current" /></div>
        <div className="space-y-1.5"><Label>Yeni şifre</Label><Input type="password" required value={f.next} onChange={set("next")} data-testid="fpc-new" /></div>
        <div className="space-y-1.5"><Label>Yeni şifre (tekrar)</Label><Input type="password" required value={f.again} onChange={set("again")} data-testid="fpc-again" /></div>
        <ul className="text-[12px] grid grid-cols-2 gap-x-3">{RULES.map(([r, l]) => <li key={l} className={r.test(f.next) ? "text-emerald-700" : "text-slate-400"}>✓ {l}</li>)}
          <li className={f.next && f.next === f.again ? "text-emerald-700" : "text-slate-400"}>✓ Tekrar eşleşiyor</li></ul>
        {err && <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded px-3 py-2" data-testid="fpc-error">{err}</div>}
        <div className="flex gap-2">
          <Button type="submit" disabled={!ok || busy} className="flex-1 bg-blue-600 hover:bg-blue-700" data-testid="fpc-submit">Şifreyi değiştir ve devam et</Button>
          <Button type="button" variant="outline" onClick={logout} data-testid="fpc-logout">Çıkış</Button>
        </div>
      </form>
    </div>
  );
}
